import { Image, Pressable, StyleSheet, Text, View } from 'react-native';
import { calcSizeForDevice, getResponsiveSize } from 'utils/index';
import { Platform } from 'utils/platform';

import KidsAvatar from 'assets/avatar-kids-circle.png';

import { Icons } from 'components/Icons';
import { WebDiv } from 'components/WebDiv';

type AvatarProps =
  | { variant: 'add'; onPress?: () => void }
  | { variant: 'kid'; onPress?: () => void }
  | { variant: 'default'; name: string; onPress?: () => void };

export const Avatar: React.FC<AvatarProps> = (props) => {
  const { variant } = props;

  const getFirstLetter = (str: string): string => str.trim().charAt(0);

  const renderContent = () => {
    if (variant === 'add')
      return (
        <Icons.Plus
          width={calcSizeForDevice(106, 152).toString()}
          height={calcSizeForDevice(106, 152).toString()}
        />
      );
    if (variant === 'kid')
      return (
        <View style={styles.imageWrapper}>
          <Image
            source={KidsAvatar}
            style={Platform.isTV ? styles.tvKidsAvatar : styles.webKidsAvatar}
            resizeMode="cover"
          />
        </View>
      );
    return (
      <Text style={Platform.isTV ? styles.tvLetter : styles.webLetter}>
        {getFirstLetter(props.name ?? '')}
      </Text>
    );
  };

  return (
    <WebDiv className="profile-avatar">
      <Pressable
        accessibilityRole="button"
        style={[styles.avatar, Platform.isTV ? styles.tvAvatar : styles.webAvatar]}
        onPress={props.onPress}>
        {renderContent()}
      </Pressable>
    </WebDiv>
  );
};

const styles = StyleSheet.create({
  avatar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#200E32',
    borderColor: '#4D64FF',
    borderWidth: 7,
  },
  tvAvatar: {
    width: calcSizeForDevice(270),
    height: calcSizeForDevice(270),
    borderRadius: calcSizeForDevice(270),
    borderWidth: 7,
  },
  webAvatar: {
    width: Number(getResponsiveSize({ base: 100, md: 180 })),
    height: Number(getResponsiveSize({ base: 100, md: 180 })),
    borderRadius: Number(getResponsiveSize({ base: 50, md: 90 })),
    borderWidth: Number(getResponsiveSize({ base: 4, md: 7 })),
  },
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    borderRadius: calcSizeForDevice(135),
    overflow: 'hidden',
  },
  tvKidsAvatar: {
    width: calcSizeForDevice(256),
    height: calcSizeForDevice(256),
  },
  webKidsAvatar: {
    width: '120%',
    height: '120%',
    marginLeft: Number(getResponsiveSize({ base: 12, md: 30 })),
    resizeMode: 'cover',
  },
  tvLetter: {
    fontSize: calcSizeForDevice(96),
    color: '#FFF',
  },
  webLetter: {
    fontSize: Number(getResponsiveSize({ base: 44, md: 96 })),
    color: '#FFF',
  },
});
